<template>
  <div class="rr-inner">
    <div class="title">退款单变更记录</div>
    <div class="list">
      <div class="item" v-for="(item, index) in dataList" :key="index">
        <div class="date">{{ item.gmtCreate }}</div>
        <div class="value">{{ item.description }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "refundRecordList",
  props: ["dataList"],
};
</script>
<style lang="scss" scoped>
@import "src/config/var";

.rr-inner {
  border-top: 1px solid $border-color;
}
.title {
  font-size: 16px;
  margin-top: 30px;
}
.list {
  margin-top: 10px;
  margin-left: 40px;
  > .item::before {
    position: absolute;
    top: 16px;
    left: -20px;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background: #3dbf3b;
    content: "";
  }
  > .item::after {
    position: absolute;
    top: 20px;
    left: -17px;
    width: 1px;
    height: 37px;
    border-radius: 4px;
    background: #3dbf3b;
    content: "";
  }
  > .item:last-child::after {
    content: none !important;
  }
  > .item {
    line-height: 40px;
    padding-left: 10px;
    position: relative;
    > .date {
      display: inline-block;
    }
    > .value {
      display: inline-block;
      margin-left: 20px;
    }
  }
}
</style>